import { FuzzyMatches } from '@nozbe/microfuzz';

export const highlightText = (text: string, searchTerm: string) => {
  if (!searchTerm) return text;
  const escapedSearchTerm = searchTerm.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
  const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    regex.test(part) ? (
      <span
        key={index}
        style={{
          backgroundColor: '#F0DBAE',
          whiteSpace: 'pre-wrap',
        }}
      >
        {part}
      </span>
    ) : (
      part.replace(/ /g, '\u00A0')
    ),
  );
};

export const highlightTextWithMatches = (text: string, match: FuzzyMatches[number] | undefined) => {
  // Just grab the first non-null highlight set (usually there’s only one anyway)
  if (!match || match.length === 0) {
    return <>{text}</>; // no matches, just show text
  }

  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  match.forEach(([start, end], i) => {
    if (lastIndex < start) {
      parts.push(<span key={`text-${i}-before`}>{text.slice(lastIndex, start)}</span>);
    }

    parts.push(<mark key={`highlight-${i}`}>{text.slice(start, end + 1)}</mark>);

    lastIndex = end + 1;
  });

  if (lastIndex < text.length) {
    parts.push(<span key="text-after">{text.slice(lastIndex)}</span>);
  }

  return <>{parts}</>;
};
